// src/components/GalleryItem/GalleryItem.jsx
import React from 'react';
import styles from './GalleryItem.module.css';

// Placeholder image if src is missing
const PLACEHOLDER_IMG = "https://via.placeholder.com/400x400.png?text=Highview";

// Expect src and alt text as props
// Added onClick prop for lightbox functionality later
const GalleryItem = ({ src, alt = "Gallery image", onClick }) => {
    const handleError = (e) => {
        e.target.onerror = null; // prevent infinite loop if placeholder fails
        e.target.src = PLACEHOLDER_IMG;
    }

    return (
        <div className={styles.galleryItem} onClick={onClick}>
            <img
                src={src || PLACEHOLDER_IMG}
                alt={alt}
                loading="lazy" // Native lazy loading
                onError={handleError}
             />
        </div>
    );
};

export default GalleryItem;